import { calendarIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const CalendarDay = createIcon({
  displayName: 'CalendarDay',
  paths: [
    'M853.333 810.667v-426.667h-682.667v426.667h682.667zM768 213.333h85.333c47.104 0 85.333 38.229 85.333 85.333v512c0 47.104-38.229 85.333-85.333 85.333h-682.667c-47.104 0-85.333-38.229-85.333-85.333v-512c0-47.104 38.229-85.333 85.333-85.333h85.333v-42.667c0-23.552 19.115-42.667 42.667-42.667s42.667 19.115 42.667 42.667v42.667h341.333v-42.667c0-23.552 19.115-42.667 42.667-42.667s42.667 19.115 42.667 42.667v42.667zM256 512c0-23.552 19.115-42.667 42.667-42.667h85.333c23.552 0 42.667 19.115 42.667 42.667v85.333c0 23.552-19.115 42.667-42.667 42.667h-85.333c-23.552 0-42.667-19.115-42.667-42.667v-85.333z'
  ],
  canvasPaths: canvasIconPaths(calendarIcon)
})
